module.exports = __webpack_public_path__ + "8a471c596670635b92ab693c38387c5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/postcode-popup/crosshairs.svg
// module id = 1285
// module chunks = 0 1